import { BigNumber } from 'ethers';
import { formatEther, parseEther } from 'ethers/lib/utils';
import { config } from '../../config/config';
import { ExtendPositionToLeverageParamsStruct } from '../../config/contracts/typechain/ITradeManager';

const generateAdjustPositionLog = (
    margin: string,
    volume: string,
    userFee: BigNumber,
    params: ExtendPositionToLeverageParamsStruct
) => {
    const targetLeverage = BigNumber.from(params.targetLeverage)
        .div(config.leverageMultiplier)
        .toString();

    const addedSize = parseEther(margin)
        .mul(parseEther(targetLeverage))
        .sub(parseEther(volume).mul(parseEther('1')))
        .div(parseEther('1').add(parseEther(targetLeverage).mul(userFee).div(100_00)));

    const openFee = addedSize.mul(userFee).div(100_00);

    const newMargin = formatEther(parseEther(margin).sub(openFee));

    const newLeverage = targetLeverage;

    const fees = formatEther(openFee);

    return { newMargin, newLeverage, fees };
};

export default generateAdjustPositionLog;
